export default "__VITE_ASSET__DbbkNIC5__"